<template>
  <a-result status="500" title="500" sub-title="Sorry, the server is wrong.">
    <template #extra>
      <a-button type="primary" @click="backHome">
        Back Home
      </a-button>
    </template>
  </a-result>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Page500",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["defaultRoutePath"])
  },
  methods: {
    backHome() {
      this.$router.replace({ path: this.defaultRoutePath });
    }
  }
};
</script>
